
global.CANVAS_SKETCH_DEFAULT_STORAGE_KEY = window.location.href;
